import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes related to user management, including paths and icons using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  MANAGE_BLOGS: {
    path: `${baseRoutes.adminBaseRoutes}/manage-blogs`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-blogger" />
      </span>
    ),
  },
    CREATE_BLOGS: {
    path: `${baseRoutes.adminBaseRoutes}/create-blogs`,
    },
UPDATE_BLOGS: {
  path: `${baseRoutes.adminBaseRoutes}/edit-blog`,
}
};

export default accessRoute;
